//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import empty from '../empty.vue';
export default {
  name: 'saas_module_plate_swipe',
  components: {
    empty: empty
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    getImg: function getImg(item) {
      if (this.value.config.image_style == '2') {
        return item.thumb;
      } else {
        return item.swipe_image || item.thumb;
      }
    }
  }
};